import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "widget" }
const _hoisted_2 = { class: "entry-form__tabs" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "entry-form__content" }
const _hoisted_6 = { class: "entry-form__row" }
const _hoisted_7 = { class: "entry-form__group" }
const _hoisted_8 = { class: "entry-form__row" }
const _hoisted_9 = { class: "entry-form__row" }
const _hoisted_10 = { class: "entry-form__group" }
const _hoisted_11 = {
  key: 0,
  class: "entry-form__group"
}

import { useI18n } from "vue-i18n";
import { ref, reactive, onMounted } from "vue";
import { EntryFormTab } from "@/models/front/EntryForm/EntryFormTab";
import { VBtn, VDatePicker, VInput, VSelect, VToggleSwitch } from "v-ferry-components";
import { outwardDateRequired, required, returnDateRequired } from "@/helpers/validators";
import useVuelidate from "@vuelidate/core";
import SvgIcon from "@/components/icons/SvgIcon.vue";
import InfoPanel from "./InfoPanel.vue";
import { EntryFormQueries } from "@/models/front/EntryForm/EntryFormState";
import { YYYYMMDD } from "@/helpers/dateHelpers";
import { startOfToday } from "date-fns";
import useRouteCodesQuery from "@/composables/settings/_useRouteCodesQuery";


export default /*@__PURE__*/_defineComponent({
  __name: 'EntryForm',
  setup(__props) {

const { t } = useI18n();

const singleJourney = ref(true);

const tabs = ref<EntryFormTab[]>([]);
const entryFormBookingUrl = ref<string>();

onMounted(() => {
    tabs.value = [
        { label: t(`entryForm.tabs.newCustomer`) }, 
        { label: t(`entryForm.tabs.existingCustomer`), url: document.getElementById("entryFormContainer")?.getAttribute("data-entryFormLoginUrl") ?? "/" },      
    ];
    entryFormBookingUrl.value = document.getElementById("entryFormContainer")?.getAttribute("data-entryFormBookingUrl") ?? "/";
});

const { data: routeOptions } = useRouteCodesQuery();

const state = reactive({
    route: "",
    outwardDate: {} as Date,
    returnDate: {} as Date,
});

const rules = {
    route: { required },
    outwardDate: { 
        required: () => outwardDateRequired(state.outwardDate)
    },
    returnDate: { 
        required: () => returnDateRequired(!singleJourney.value, state.returnDate, state.outwardDate)
    },
};

const v$ = useVuelidate(rules, state);

const submitForm = async () => {
    const isValid = await v$.value.$validate();

    if (!isValid) return;

    let queryParams: EntryFormQueries = {
        route: state.route,
        outwardDate: YYYYMMDD(state.outwardDate),
    };

    if (!singleJourney.value) {
        queryParams = {
            ...queryParams,
            returnDate: YYYYMMDD(state.returnDate),
        };
    }

    const searchParams = new URLSearchParams(queryParams).toString();
    const redirectUrl = `${entryFormBookingUrl.value}?${searchParams}`;

    window.location.href = redirectUrl;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "entry-form",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["entry-form__tab", { active: !tab.url }]),
            key: index
          }, [
            (!tab.url)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(tab.label), 1))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: tab.url
                }, [
                  _createElementVNode("span", null, _toDisplayString(tab.label), 1),
                  _createVNode(SvgIcon, {
                    icon: "external-link",
                    height: "1rem",
                    width: "1rem"
                  })
                ], 8, _hoisted_4))
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", null, _toDisplayString(singleJourney.value ? _ctx.$t('entryForm.title.singular') : _ctx.$t('entryForm.title.plural')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(VSelect), {
              label: _ctx.$t('entryForm.labels.route'),
              options: _unref(routeOptions),
              hasError: _unref(v$).route.$error,
              modelValue: _unref(v$).route.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).route.$model) = $event))
            }, null, 8, ["label", "options", "hasError", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(VToggleSwitch), {
            label: _ctx.$t('entryForm.labels.singleJourney'),
            modelValue: singleJourney.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((singleJourney).value = $event))
          }, null, 8, ["label", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(VDatePicker), {
              modelValue: _unref(v$).outwardDate.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).outwardDate.$model) = $event)),
              minDate: _unref(startOfToday)(),
              popover: { visibility: 'focus', transition: 'none' }
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createVNode(_unref(VInput), _mergeProps({
                  label: _ctx.$t('entryForm.labels.outwardDate'),
                  hasError: _unref(v$).outwardDate.$error,
                  modelValue: inputValue,
                  autocomplete: "off"
                }, _toHandlers(inputEvents)), {
                  icon: _withCtx(() => [
                    _createVNode(SvgIcon, {
                      class: "calendar-icon",
                      icon: "edit-calendar",
                      height: "1rem"
                    })
                  ]),
                  _: 2
                }, 1040, ["label", "hasError", "modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue", "minDate"])
          ]),
          (!singleJourney.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(VDatePicker), {
                  modelValue: _unref(v$).returnDate.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).returnDate.$model) = $event)),
                  minDate: state.outwardDate || _unref(startOfToday)(),
                  popover: { visibility: 'focus', transition: 'none' }
                }, {
                  default: _withCtx(({ inputValue, inputEvents }) => [
                    _createVNode(_unref(VInput), _mergeProps({
                      label: _ctx.$t('entryForm.labels.returnDate'),
                      autocomplete: "off",
                      hasError: _unref(v$).returnDate.$error,
                      modelValue: inputValue
                    }, _toHandlers(inputEvents)), {
                      icon: _withCtx(() => [
                        _createVNode(SvgIcon, {
                          class: "calendar-icon",
                          icon: "edit-calendar",
                          height: "1rem"
                        })
                      ]),
                      _: 2
                    }, 1040, ["label", "hasError", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "minDate"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(VBtn), { type: "submit" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("entryForm.buttons.submit")), 1)
          ]),
          _: 1
        })
      ])
    ], 32),
    _createVNode(InfoPanel, {
      btnText: _ctx.$t('entryForm.buttons.infoPanel')
    }, null, 8, ["btnText"])
  ]))
}
}

})